<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width" no-footer-line>
        <div class="col-12">
          <h4>Sub Topic</h4>
          <p>{{ subTopic.description }}</p>
          <div class="row">
            <router-view/>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SubTopic',
  computed: {
    subTopic() {
      return this.$store.getters['subTopic/get']
    }
  },
  mounted() {
    if (!this.$store.getters['subTopic/hasSubTopic']) this.$router.go(-1)
  }
}
</script>
<style lang="scss" scoped>
</style>
